// Blocks the Activities settings tab can render and write for one activity. The values are the actual keys under
// `session.activities.<activity>`, so the same member names the payload, the per-activity allow-list and the UI row.
export enum ActivityAiBlock {
    Transcription = 'transcription',
    StreamAudio = 'streamAudio',
    VoiceReply = 'voiceReply',
    Compliance = 'compliance',
    ConversationSummary = 'conversationSummary',
    ChatbotEndSession = 'chatbotEndSession',
    // The agent chatbot activity keeps its settings flat rather than in a named block.
    Enabled = 'enabled',
    Provider = 'provider',
    StoreHistory = 'storeHistory'
}
